import { render, staticRenderFns } from "./SearchBoxAutocomplete.vue?vue&type=template&id=82487466&scoped=true&"
import script from "./SearchBoxAutocomplete.vue?vue&type=script&lang=js&"
export * from "./SearchBoxAutocomplete.vue?vue&type=script&lang=js&"
import style0 from "./SearchBoxAutocomplete.vue?vue&type=style&index=0&id=82487466&prod&lang=scss&scoped=true&"
import style1 from "./SearchBoxAutocomplete.vue?vue&type=style&index=1&id=82487466&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82487466",
  null
  
)

export default component.exports